import { render, staticRenderFns } from "./MpcMy.vue?vue&type=template&id=3e0ef6ff&scoped=true"
import script from "./MpcMy.vue?vue&type=script&lang=js"
export * from "./MpcMy.vue?vue&type=script&lang=js"
import style0 from "./MpcMy.vue?vue&type=style&index=0&id=3e0ef6ff&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0ef6ff",
  null
  
)

export default component.exports